import React from 'react';
import styles from './OrderList.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { allProducts } from "../../../API/ProductsAPI";

const OrderList = (props) => {
    let total = props.cart.reduce((total, product) => total + product.quantity * allProducts[product.id].prices[product.priceIndex].price, 0);

    return (
        <div className={styles.container}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.left}>Produs</th>
                        <th className={styles.centered}>Cantitate</th>
                        <th className={styles.centered}>Preț</th>
                    </tr>
                </thead>
                <tbody>
                    {props.cart.map((product, index) => (
                        <tr key={index}>
                            <td>
                                <img src={allProducts[product.id].image} className={styles.image} />
                                <span className={styles.productName}>{allProducts[product.id].name}</span>
                            </td>
                            <td className={styles.centered}>{product.quantity}</td>
                            <td className={styles.right}>{allProducts[product.id].prices[product.priceIndex].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td className={styles.right}>Subtotal:</td>
                        <td></td>
                        <td className={styles.right}>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</td>
                    </tr>
                    <tr>
                        <td className={styles.right}>Taxe:</td>
                        <td></td>
                        <td className={styles.right}>0 €</td>
                    </tr>
                    <tr>
                        <td className={styles.right}>Total:</td>
                        <td></td>
                        <td className={styles.right}>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default OrderList;
